import React from "react";
import {
    Phone,
    Mail,
    MessageCircle,
    HelpCircle,
    Bug,
    Star,
    ChevronRight
} from "lucide-react";

import "./DeliverySupport.css";

function DeliverySupport() {

    const supportItems = [

        {
            title: "Call Support",
            subtitle: "Talk to HomeFoods Support Team",
            icon: <Phone size={22} />,
            color: "#16a34a",
            action: () => {
                window.location.href = "tel:+919999999999";
            }
        },

        {
            title: "Email Support",
            subtitle: "support@homefoods.in",
            icon: <Mail size={22} />,
            color: "#2563eb",
            action: () => {
                window.location.href =
                    "mailto:support@homefoods.in";
            }
        },

        {
            title: "WhatsApp Support",
            subtitle: "Chat with us instantly",
            icon: <MessageCircle size={22} />,
            color: "#22c55e",
            action: () => {
                window.open(
                    "https://wa.me/919999999999",
                    "_blank"
                );
            }
        },

        {
            title: "Frequently Asked Questions",
            subtitle: "Common questions & answers",
            icon: <HelpCircle size={22} />,
            color: "#f59e0b",
            action: () => {
                alert("FAQ Coming Soon");
            }
        },

        {
            title: "Report an Issue",
            subtitle: "Found a bug? Let us know",
            icon: <Bug size={22} />,
            color: "#ef4444",
            action: () => {
                alert("Bug Report Coming Soon");
            }
        },

        {
            title: "Rate HomeFoods",
            subtitle: "Share your feedback",
            icon: <Star size={22} />,
            color: "#eab308",
            action: () => {
                alert("Rating Feature Coming Soon");
            }
        }

    ];

    return (

        <div className="delivery-support-page">

            <div className="support-header">

                <h1>

                    Help & Support

                </h1>

                <p>

                    We're always here to help.

                </p>

            </div>

            <div className="support-list">

                {

                    supportItems.map((item, index) => (

                        <div

                            key={index}

                            className="support-card"

                            onClick={item.action}

                        >

                            <div className="support-left">

                                <div
                                    className="support-icon"
                                    style={{
                                        background: item.color
                                    }}
                                >

                                    {item.icon}

                                </div>

                                <div>

                                    <h3>

                                        {item.title}

                                    </h3>

                                    <p>

                                        {item.subtitle}

                                    </p>

                                </div>

                            </div>

                            <ChevronRight size={20} />

                        </div>

                    ))

                }

            </div>

        </div>

    );

}

export default DeliverySupport;